import React from "react";
import PageBody from "../components/AntiMoneyLaundering/PageBody";
import WebsiteLayout from "../components/layouts/WebsiteLayout";

const AntiMoney = () => {
  return (
    <WebsiteLayout>
      <PageBody />
    </WebsiteLayout>
  );
};

export default AntiMoney;
